import getStore from "../store/store";
import { mutatorAction } from "satcheljs";
import type { QuickStepsConfig } from "../store/schema/QuickStepsConfig";
import type { MailboxInfo } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import { logUsage } from "owa-analytics";
import { QuickStepsLoadState } from "../store/schema/QuickStepsLoadState";

export const initializeQuickStepsMutator: (mailboxInfo: MailboxInfo, quickStepsConfig: QuickStepsConfig, overwrite?: boolean) => void = mutatorAction("initializeQuickSteps", (mailboxInfo: MailboxInfo, quickStepsConfig: QuickStepsConfig, overwrite?: boolean): void => {
    const store = getStore();
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    if (!store.quickStepsStoreMap.has(accountKey) || overwrite) {
        store.quickStepsStoreMap.set(accountKey, {
            version: quickStepsConfig.version,
            quickSteps: quickStepsConfig.quickSteps,
            errorState: quickStepsConfig.errorState,
            runOnce: quickStepsConfig.runOnce,
        });
        
        logUsage("QuickStepTotal", mailboxInfo, [quickStepsConfig.quickSteps.length]);
    }
    store.loadingStatesMap.set(accountKey, quickStepsConfig.errorState
        ? QuickStepsLoadState.ConfigError
        : QuickStepsLoadState.Loaded);
});
